import React, {useEffect, useState} from "react";
import { useSpring, animated } from 'react-spring';
import './checkbox.scss';

const Checkbox = ({name, label, onChange, value, validate}) => {
    const [touched, setTouched] = useState(false);
    const [checked, setChecked] = useState(false);

    const style = useSpring({
        opacity: touched && !value ? 1 : 0,
        zIndex: touched && !value ? 1 : -1,
        immediate: true
    })

    const onClick = () => {
        const ck = checked;

        onChange(!ck, !!ck)
        setChecked(!ck)
    }

    useEffect(() => {
        if (validate) {
            setTouched(true);
        }
    }, [validate])

    return <div className={'checkbox-main'}>
        <div>
            <animated.div style={style} onClick={onClick}/>
            <input
                type="checkbox"
                id={name}
                name={name}
                onChange={onClick}
                onBlur={() => setTouched(true)}
                onFocus={() => setTouched(false)}
                checked={checked}
            />
        </div>
        <label htmlFor={name}>{label}</label>
        <span className={touched && !value ? 'error-msg' : ''}>
            Rellena este campo obligatorio
        </span>
    </div>
}

export default Checkbox;